import * as types from "../constants/actionsTypes";

const initialState = {
  filters: null,
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case types.FILTERS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        filters: []
      };
    case types.FILTERS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        filters: action.data
      };
    case types.FILTERS_LOAD_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/filtersReducer.js